
import { Box } from '@mui/system'
import React from 'react'
import { Route, Routes } from 'react-router-dom'
import "./App.css"
import Footer from './Components/Footer'
import Navbar from './Components/Navbar'
import ExerciseDetail from './Pages/ExerciseDetail'
import Home from './Pages/Home'
const App = () => {
  return (
    <div>
      <Box sx={{width: {xl:"1488px"}}} m="auto">
        <Navbar/>
        <Routes>
          <Route path='/' element={<Home/>} />
          <Route path='/exercise/:id' element={<ExerciseDetail/>} />
        </Routes>
        {/* <Footer/> */}
      </Box>
    </div>
  )
}

export default App
